import PropTypes from "prop-types";
import formatCurrency from "asos-currency-formatter";

const Price = ({ currencyId, storeCode, value }) =>
  formatCurrency({ currency: currencyId, store: storeCode, value });

Price.defaultProps = {
  value: null
};

Price.propTypes = {
  currencyId: PropTypes.number.isRequired,
  storeCode: PropTypes.string.isRequired,
  value: PropTypes.string
};

export default Price;



// WEBPACK FOOTER //
// ./template/components/Price/Price.js